var _path, _g, _g2, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 10.5H1.75C1.6837 10.5 1.62011 10.4895 1.57322 10.4707C1.52634 10.4519 1.5 10.4264 1.5 10.3999V9.80033C1.5 9.72068 1.57902 9.64429 1.71967 9.58796C1.86032 9.53164 2.05109 9.5 2.25 9.5H9.75C9.94891 9.5 10.1397 9.53164 10.2803 9.58796C10.421 9.64429 10.5 9.72068 10.5 9.80033V10.3999C10.5 10.4264 10.4737 10.4519 10.4268 10.4707C10.3799 10.4895 10.3163 10.5 10.25 10.5Z",
    fill: "#363636"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3676_63980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 2.99976C10.3186 2.99986 10.1405 3.04937 9.98498 3.14298C9.82946 3.23658 9.70235 3.37075 9.61728 3.5311C9.53221 3.69145 9.49239 3.87193 9.50209 4.05319C9.51179 4.23445 9.57064 4.40965 9.67233 4.56001L7.61433 6.32251L6.40983 2.90976C6.61857 2.816 6.78883 2.65348 6.89221 2.44934C6.99559 2.2452 7.02583 2.01178 6.97789 1.78803C6.92994 1.56429 6.80671 1.36375 6.62876 1.21989C6.45081 1.07604 6.22891 0.997559 6.00008 0.997559C5.77126 0.997559 5.54936 1.07604 5.37141 1.21989C5.19346 1.36375 5.07023 1.56429 5.02228 1.78803C4.97434 2.01178 5.00458 2.2452 5.10796 2.44934C5.21134 2.65348 5.3816 2.816 5.59033 2.90976L4.38584 6.32251L2.32784 4.56001C2.45288 4.37512 2.51249 4.15372 2.49715 3.93104C2.48181 3.70837 2.39242 3.49722 2.2432 3.33123C2.09398 3.16524 1.89352 3.05394 1.67373 3.01505C1.45394 2.97616 1.22746 3.01193 1.03035 3.11664C0.833238 3.22136 0.676825 3.38902 0.586016 3.59291C0.495206 3.79681 0.475222 4.02522 0.529244 4.24179C0.583265 4.45835 0.708188 4.65062 0.884121 4.78798C1.06005 4.92534 1.27688 4.99989 1.50009 4.99976C1.55883 4.99902 1.61739 4.99308 1.67509 4.98201L2.75009 8.53651V9.49976H9.25008V8.53651L10.3251 4.98201C10.4624 5.00817 10.6036 5.00526 10.7397 4.97347C10.8758 4.94168 11.0037 4.88172 11.1152 4.79744C11.2267 4.71317 11.3193 4.60646 11.3871 4.4842C11.4548 4.36194 11.4961 4.22684 11.5084 4.08762C11.5207 3.9484 11.5037 3.80815 11.4584 3.67592C11.4132 3.54368 11.3407 3.4224 11.2457 3.3199C11.1507 3.2174 11.0352 3.13595 10.9068 3.08081C10.7784 3.02566 10.6398 2.99805 10.5001 2.99976Z",
    fill: "#E67C1B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3676_63980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.49658H9.75C9.94891 9.49658 10.1397 9.5756 10.2803 9.71625C10.421 9.8569 10.5 10.0477 10.5 10.2466V10.4966H1.5V10.2466C1.5 10.0477 1.57902 9.8569 1.71967 9.71625C1.86032 9.5756 2.05109 9.49658 2.25 9.49658Z",
    fill: "#FFAE00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6.55228 3 7 2.55228 7 2C7 1.44772 6.55228 1 6 1C5.44772 1 5 1.44772 5 2C5 2.55228 5.44772 3 6 3Z",
    fill: "#FFAE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.99951C11.0523 4.99951 11.5 4.5518 11.5 3.99951C11.5 3.44723 11.0523 2.99951 10.5 2.99951C9.94772 2.99951 9.5 3.44723 9.5 3.99951C9.5 4.5518 9.94772 4.99951 10.5 4.99951Z",
    fill: "#FFAE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 4.99951C2.05228 4.99951 2.5 4.5518 2.5 3.99951C2.5 3.44723 2.05228 2.99951 1.5 2.99951C0.947715 2.99951 0.5 3.44723 0.5 3.99951C0.5 4.5518 0.947715 4.99951 1.5 4.99951Z",
    fill: "#FFAE00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3676_63980",
    x: 0.499512,
    y: 0.997559,
    width: 11.0127,
    height: 10.5024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3676_63980"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3676_63980",
    x: 1.5,
    y: 9.49658,
    width: 9,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.33 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3676_63980"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.db9459d7e322cb0d7928b6768b4214d7.svg";
export { ForwardRef as ReactComponent };